import React from "react";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../reusebale/breadcrumbs";
import InvoiceListing from "./invoice-listing";
import PlanDetails from "./plan-details";
import AddProperty from "./add-property";

const MainPayment = ({ onBack }) => {
  const { loginSuccess, userCompleteProfile } = useSelector(
    (state) => state.auth
  );

  // Check if user has active subscriptions to show AddProperty component
  const hasActiveSubscriptions =
    userCompleteProfile?.subscriptionPackage?.length > 0;

  return (
    <div className="mt-6 w-full">
      <Breadcrumbs
        recordId={`${loginSuccess?.user?.firstName} ${loginSuccess?.user?.lastName}`}
        subheading="My Account"
        onBack={onBack}
      />

      {/* Original Invoice Listing and Plan Details - 60/40 split */}
      <div className="flex justify-between mt-5 gap-4 h-[600px]">
        <div className="w-[60%] h-full">
          <InvoiceListing />
        </div>
        <div className="w-[40%] h-full">
          <PlanDetails />
        </div>
      </div>

      {/* Add Property Button */}
      {hasActiveSubscriptions && (
        <div className="mt-4">
          <AddProperty />
        </div>
      )}

      {!hasActiveSubscriptions && (
        <div className="mt-4 w-full h-[200px] flex items-center justify-center bg-gray-50 rounded-lg border border-gray-200">
          <div className="text-center text-gray-500">
            <p className="font-popinsSemiBold text-lg">Add Properties</p>
            <p className="font-popinsMedium text-sm mt-1">
              Available after purchasing a subscription plan
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainPayment;
